import styled from 'styled-components'

export const LogoContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 16px;
`
